'use strict';

/*global services*/
/*global blockElement*/
/*global unBlockElement*/

$(document).bind('pageLoaded', function () {
    $('button.basket-customer-edit').click(function () {        
        var $boxWrapper = $('.basket-user-summary-wrapper .basket-customer-summary');    
        blockElement($boxWrapper);
        $.postCORS(services.get('configurations').param('DomainURL') + '/?action=basket&method=js_load_edit_customer', null, function (res) {
            $('.basket-order-form-submit button[type="submit"]').prop('disabled', true);
            unBlockElement($boxWrapper);
            try {
                res = JSON.parse(res);
                if(res.msg === 'SUCCESS') {
                    $boxWrapper.html(res.data.html);
                } else {
                    services.get('development').viewSiteErrorMsg(res);
                }
            } catch(e) {
                services.get('development').viewSiteErrorMsg(res, e);
            }
        });               
    });   
    
    $('.basket-user-summary-wrapper').on('click', '.basket-customer-save', function () {       
        var $boxWrapper = $('.basket-user-summary-wrapper .basket-customer-summary');    
        var $customerForm = $('.basket-user-summary-wrapper form.form-basket-customer-edit');   
                                                           
        if ($('#form-basket-customer-edit').valid()) {            
            blockElement($boxWrapper);
            $.postCORS(services.get('configurations').param('DomainURL') + '/?action=basket&method=js_load_edit_customer', $customerForm.serialize(), function (res) {
                unBlockElement($boxWrapper);
                try {
                    res = JSON.parse(res);
                    if(res.msg === 'SUCCESS') {
                        if (res.data.html.includes('basket-customer-summary')) {    
                            $('.basket-order-form-submit button[type="submit"]').prop('disabled', false); 
                        }
                        $boxWrapper.html(res.data.html);
                    } else {
                        services.get('development').viewSiteErrorMsg(res);
                    }
                } catch(e) {
                    services.get('development').viewSiteErrorMsg(res, e);
                }
            });        
        } 
 
        return false;
    });                
});
